import { keyframes, stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const qrModuleAnimationOpen = keyframes({
  from: { top: '100%' },
  to: { top: '0%' },
});

const qrModuleAnimationClose = keyframes({
  from: { top: '0%' },
  to: { top: '100%' },
});

const styles = stylesheet({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    height: '100vh',
    width: '100vw',
    flexDirection: 'column',
    zIndex: 6,
  },
  overlayContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    height: '100vh',
    width: '100vw',
    flexDirection: 'column',
    // zIndex: 5,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '84px',
    padding: '0px 24px',
    color: colors.white,
    backgroundColor: colors.darkBlueBackground,
    zIndex: 5,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLeftIcon: {
    height: 24,
    width: 24,
    marginRight: 16,
  },
  headerLeftText: {
    fontWeight: font.weight.light,
    fontSize: 28,
    lineHeight: '36px',
    letterSpacing: '-0.21px',
  },
  headerRight: {
    textAlign: 'end',
  },
  headerRightText: {
    fontWeight: font.weight.bold,
    fontSize: 20,
    lineHeight: '24px',
    letterSpacing: '-0.15px',
  },
  headerRightSubtext: {
    fontSize: 16,
    lineHeight: '20px',
  },
  scannerContainer: {
    position: 'relative',
    flex: 1,
    backgroundColor: colors.black,
  },
  scannerContainerWithOpacity: {
    position: 'relative',
    flex: 1,
    backgroundColor: colors.black,
    opacity: '80%',
  },
  scannerLoader: {
    position: 'absolute',
    top: '-5vh',
    left: 0,
    height: '100%',
    width: '100%',
  },
  scanner: {
    height: '100%',
    $nest: {
      '&>section': {
        height: '100%',
      },
    },
  },
  scannerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  scannerOverlayWithOpacity: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    opacity: '80%',
  },
  scannerLegacyText: {
    color: colors.white,
    fontWeight: font.weight.light,
    fontSize: '28px',
    textAlign: 'center',
    lineHeight: '33px',
    padding: 32,
  },
  scannerOverlayBoxWrapper: {
    position: 'relative',
    height: '100vw',
    width: '100vw',
    padding: '8vw',
    top: '-5vh',
  },
  scannerOverlayBox: {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundImage: `
      linear-gradient(to right, white 100px,transparent 100px),
      linear-gradient(to right, white 100px, transparent 100px),
      linear-gradient(to bottom, white 100px, transparent 100px),
      linear-gradient(to bottom, white 100px, transparent 100px)
      `,
    backgroundSize: '100% 4px, 100% 4px, 4px 100%, 4px 100%',
    backgroundPosition: '-50px 0%, -50px 100%, 0% -50px, 100% -50px',
    backgroundRepeat: 'repeat-x, repeat-x, repeat-y, repeat-y',
    zIndex: 1,
  },
  scannerOverlayBoxInnerWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    padding: '12vw',
  },
  scannerOverlayBoxInner: {
    height: '100%',
    width: '100%',
    boxShadow: '0px 0px 0px 100vh rgba(0, 0, 0, 0.5)',
  },
  scannerOverlayText: {
    color: colors.white,
    fontWeight: font.weight.light,
    fontSize: '28px',
    textAlign: 'center',
    lineHeight: '33px',
    position: 'absolute',
    bottom: 'calc(100% + 16px)',
    left: 0,
    width: '100%',
  },
  qrCodeScanOpen: {
    animationName: qrModuleAnimationOpen,
    animationDuration: '0.5s',
  },
  qrCodeScanClose: {
    animationName: qrModuleAnimationClose,
    animationDuration: '0.5s',
  },
});

export default styles;
